module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// D:/Projects/MDA/schoolofmusic-ucla/web/app/themes/ucla/node_modules/axios/index.js
// module id = 34
// module chunks = 0